import { render, staticRenderFns } from "./PartnerSuggestor.vue?vue&type=template&id=b21a8300&"
import script from "./PartnerSuggestor.vue?vue&type=script&lang=js&"
export * from "./PartnerSuggestor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports